// eslint-disable-next-line import/prefer-default-export
export const transformVNodeClassToObject = source => {
  if (source === undefined && source === null) {
    return {};
  }
  if (typeof source === 'string') {
    return { [source]: true };
  }
  if (Array.isArray(source)) {
    return source.reduce((accumulator, item) => {
      if (typeof item === 'string') {
        return {
          ...accumulator,
          [item]: true,
        };
      }
      return {
        ...accumulator,
        ...item,
      };
    }, {});
  }
  return source;
};
